import React, { useEffect, Suspense } from 'react';
import { useImmer } from 'use-immer';
import { useFormik } from 'formik';
import * as Yup from 'yup';
import { Card, Form, Col, Button, Alert } from 'react-bootstrap'
import FormControls from '../../controls/formControls';
import { AuthenticationService } from '../../services';
import { BusyButton } from '../../controls/Buttons';

const resetPasswordObjInitValues = {
    username: '',
    password: '',
    fingerprint: '',
    newPassword: '',
    newPasswordConfirm: ''
}

const resetPasswordValsValidation = Yup.object().shape({
    newPassword: Yup.string()
        .matches(/^(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.*[@$!%*?&]).{8,}$/, 'Your new password must contain at least one upper case letter, one lower case leter, one number, one special character (@$!%*?&), and a minimum of eight characters.')
        .notOneOf([Yup.ref('password'), null], 'New password cannot be the same as current password.')
        .required('No password entered.'),
    newPasswordConfirm: Yup.string()
        .oneOf([Yup.ref('newPassword'), null], 'Passwords must match.')
});

const ChangePasswordAndLoginModal = (props) => {

    const [resetPasswordObj, setResetPasswordObj] = useImmer(resetPasswordObjInitValues);
    const [error, setError] = useImmer('');

    useEffect(() => {
        setResetPasswordObj(draft => {
            Object.assign(draft, props.model)
        })
    }, []);

    const formik = useFormik({
        initialValues: resetPasswordObj,
        validationSchema: resetPasswordValsValidation,
        enableReinitialize: true,
        onSubmit: async (values, { setSubmitting, setErrors, setStatus, resetForm, setFieldValue }) => {
            setError('');
            var authService = new AuthenticationService();
            var returnVal = await authService.changePasswordAndAuthenticate(values);
            if (returnVal.result) {
                props.processAuthenticationResult(returnVal, values, setFieldValue);
                props.closeModal();
            } else {
                setError(returnVal.message);
                //showAlertModal("Success!", returnVal.message);
            }
            setSubmitting(false);
        }
    });

    return (
        <Card>
            <Card.Header className="d-flex align-items-center">
                <div className="mr-auto" >Password Expired</div>
                <div className="card-btn-group">
                </div>
            </Card.Header>
            <Card.Body>
                <Alert variant='danger' show={error}>{error}</Alert>
                <p>
                    Your password has expired.  Please enter a new password below and click the 'Change Password' button to change your password.
                </p>
                <Form.Row>
                    <Form.Group as={Col} >
                        <FormControls.Textbox
                            type="password"
                            name="newPassword"
                            label="New Password"
                            formHandler={formik}
                            placeholder="Enter new password"
                            type="password"
                        />

                    </Form.Group>
                </Form.Row>
                <Form.Row>
                    <Form.Group as={Col} >
                        <FormControls.Textbox
                            type="password"
                            name="newPasswordConfirm"
                            label="Confirm New Password"
                            formHandler={formik}
                            placeholder="Enter new password again"
                            type="password"
                        />
                    </Form.Group>
                </Form.Row>
                <Form.Row>
                    <Col>
                        <BusyButton variant="primary" onClick={() => formik.submitForm()}>Reset Password</BusyButton>
                    </Col>
                </Form.Row>
            </Card.Body>
        </Card>
    );
}
export default ChangePasswordAndLoginModal;